module.exports = __webpack_public_path__ + "static/media/sub_about_trophy.9636e621.png";